import { white } from '@carbon/elements';

// Note, this is probably going to be removed in v2, we don't use it for anything
const theme = {
  colors: { ...white },
};

export default theme;
